import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import Productos from './ViewModal/Productos';
import Referencias from './ViewModal/Referencias';
import Footer from './ViewModal/Footer';
import Cuotas from './ViewModal/Cuotas';

const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class ViewModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Crédito"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaStr}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    />
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.tipoCambio}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '40%' }}
                                        value={this.props.formValues.serie}
                                    />
                                    <Input readOnly
                                        style={{ width: '60%' }}
                                        value={this.props.formValues.documento}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Días / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.diasVencimiento}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaVencimientoStr}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Moneda">
                                <Input readOnly
                                    value={this.props.formValues.nombreMoneda}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Establecimiento">
                                <Input readOnly
                                    value={this.props.formValues.nombreEstablecimiento}
                                />
                            </Form.Item>
                        </div>


                        <div className="col-md-3">
                            <Form.Item label="Almacén">
                                <Input readOnly
                                    value={this.props.formValues.nombreAlmacen}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Lista de Precio">
                                <Input readOnly
                                    value={this.props.formValues.nombreListaPrecio}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Vendedor">
                                <Input readOnly
                                    value={this.props.formValues.nombreVendedor}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Cliente">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.numeroDocumentoCliente}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.nombreCliente}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Dirección">
                                <Input readOnly
                                    value={this.props.formValues.direccionCliente}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Observación">
                                <Input readOnly
                                    value={this.props.formValues.observacion}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Tipo Prestamo">
                                <Input readOnly
                                    value={this.props.formValues.prestamo}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Nro Contrato">
                                <Input readOnly
                                    value={this.props.formValues.nroContrato}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Facturacion">
                                <Input readOnly
                                    value={this.props.formValues.nombreTipoComprobante}
                                />
                            </Form.Item>
                        </div>
                        {this.props.formValues.idPrestamo == 1 ? (

                            <>
                                <div className="col-md-3">
                                    <Form.Item label="Cultivo">
                                        <Input readOnly
                                            value={this.props.formValues.cultivo}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="col-md-3">
                                    <Form.Item label="Etapa Fenologica">
                                        <Input readOnly
                                            value={this.props.formValues.tipoFenologica}
                                        />
                                    </Form.Item>
                                </div>
                            </>
                        ) :

                            <>
                                <div className="col-md-3">
                                    <Form.Item label="Placa">
                                        <Input readOnly
                                            value={this.props.formValues.placa}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="col-md-3">
                                    <Form.Item label="Nro Serie">
                                        <Input readOnly
                                            value={this.props.formValues.nroSerie}
                                        />
                                    </Form.Item>
                                </div>
                            </>

                        }



                        <div className="col-md-3">
                            <Form.Item label="Tipo de Servicio">
                                <Input readOnly
                                    value={this.props.formValues.tipoProducto}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Tipo de Crédito">
                                <Input readOnly
                                    value={this.props.formValues.tipoCredito}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Tasa de Interes">
                                <Input readOnly
                                    value={this.props.formValues.tipoInteres}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Frecuencia de Cuotas">
                                <Input readOnly
                                    value={this.props.formValues.frecuencia}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Nro Dias">
                                <Input readOnly
                                    value={this.props.formValues.nroDias}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Fecha de Inicio de CUOTAS">
                                <Input readOnly
                                    value={this.props.formValues.fechaInicioStr}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <Productos
                                        dataSource={this.props.formValues.detalles}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <Referencias
                                        dataSource={this.props.formValues.referencias}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Cuotas" key="3">
                                    <Cuotas
                                        dataSource={this.props.formValues.cuotas}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <Footer
                        formValues={this.props.formValues}
                    />
                </Form>
            </Modal>
        );
    }
}